import { render, staticRenderFns } from "./ProjectGoals.vue?vue&type=template&id=f7b0582e&scoped=true"
import script from "./ProjectGoals.vue?vue&type=script&lang=js"
export * from "./ProjectGoals.vue?vue&type=script&lang=js"
import style0 from "./ProjectGoals.vue?vue&type=style&index=0&id=f7b0582e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b0582e",
  null
  
)

export default component.exports